"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcLabelsFor = exports.getViewFieldsFromQuestions = void 0;
const ViewFieldKey_1 = __importDefault(require("@opsbase/lib-data-viewfield/ViewFieldKey"));
const Language_1 = __importDefault(require("@opsbase/lib-i18n/Language"));
const formQuestionsToFormWithTree_1 = __importDefault(require("../convert/formQuestionsToFormWithTree"));
const FormQuestionType_1 = __importDefault(require("../FormQuestionType"));
const getAllQuestions_1 = __importDefault(require("./getAllQuestions"));
const getAnswerFieldTypeFromQuestionType_1 = __importDefault(require("./getAnswerFieldTypeFromQuestionType"));
const viewableQuestionTypes = [
    FormQuestionType_1.default.CHECK,
    FormQuestionType_1.default.DATETIME,
    FormQuestionType_1.default.LIST,
    FormQuestionType_1.default.NUMBER,
    FormQuestionType_1.default.PHOTO,
    FormQuestionType_1.default.RATING,
    FormQuestionType_1.default.TEXT,
    FormQuestionType_1.default.SIGNATURE,
    FormQuestionType_1.default.SPT,
    FormQuestionType_1.default.ASSET,
];
function getViewFieldsFromQuestions(qs, language) {
    const form = (0, formQuestionsToFormWithTree_1.default)(qs);
    return (0, getAllQuestions_1.default)(form.questionTree)
        .filter(questionNode => viewableQuestionTypes.indexOf(questionNode.type) >= 0)
        .map(questionNode => {
        return Object.assign(Object.assign({}, calcLabelsFor(questionNode, form, language)), { key: ViewFieldKey_1.default.QUESTIONANSWER, fieldType: (0, getAnswerFieldTypeFromQuestionType_1.default)(questionNode.type), questionNodeId: questionNode.nodeId, description: questionNode.title, width: 150, sortable: false, gqlFields: 'form, isScoreEnabled' });
    });
}
exports.getViewFieldsFromQuestions = getViewFieldsFromQuestions;
exports.default = getViewFieldsFromQuestions;
function calcLabelsFor(q, form, language) {
    var _a, _b, _c, _d;
    const isAlt = language !== Language_1.default.ENGLISH;
    let label = q === null || q === void 0 ? void 0 : q.title;
    label = isAlt ? ((_a = q === null || q === void 0 ? void 0 : q.titleAlt) === null || _a === void 0 ? void 0 : _a[language]) || label : label;
    let aggLabel;
    let aggFlag;
    if ((q === null || q === void 0 ? void 0 : q.type) === FormQuestionType_1.default.CHECK) {
        const rule = form.rules[q.questionId];
        const currentV = isAlt ? ((_b = rule.yes.labelAlt) === null || _b === void 0 ? void 0 : _b[language]) || rule.yes.label : rule.yes.label;
        aggLabel = currentV;
        aggFlag = rule.yes.flag;
    }
    if (q === null || q === void 0 ? void 0 : q.repetitionAncestorId) {
        const repetitionAncestor = form.questions[q.repetitionAncestorId];
        const rule = form.rules[repetitionAncestor.questionId];
        if (rule.list.enabled) {
            const option = rule.list.options[q.repetitionIndex];
            let optionLabel = option.label;
            optionLabel = isAlt ? ((_c = option.labelAlt) === null || _c === void 0 ? void 0 : _c[language]) || label : label;
            label = `${optionLabel}: ${label}`;
        }
        else {
            let repAnscestorTitle = repetitionAncestor.title;
            repAnscestorTitle = isAlt
                ? ((_d = repetitionAncestor.titleAlt) === null || _d === void 0 ? void 0 : _d[language]) || repAnscestorTitle
                : repAnscestorTitle;
            label = `${repAnscestorTitle} : ${label}`;
        }
    }
    //if (label.length > 50) label = `${label.substr(0, 50)}...`
    return {
        label,
        aggLabel,
        aggFlag,
    };
}
exports.calcLabelsFor = calcLabelsFor;
